import React from 'react';
import { Stack } from '@mui/material';
import { DataTestIds } from 'src/config/dataTestIds';
import * as S from './PractitionerDetails.styles';
const PractitionerDetails = ({
  size = 'medium',
  title,
  subTitle,
  description,
  avatar,
  rightCorner,
  footer,
  ...other
}) => /*#__PURE__*/React.createElement(Stack, other, /*#__PURE__*/React.createElement(S.Header, null, avatar && /*#__PURE__*/React.createElement(S.Avatar, null, avatar), /*#__PURE__*/React.createElement(S.HeaderContent, null, title && /*#__PURE__*/React.createElement(S.Title, {
  "data-testid": DataTestIds.PractitionerCardTitle,
  size: size
}, title, rightCorner && /*#__PURE__*/React.createElement(S.RightCorner, null, rightCorner)), subTitle && /*#__PURE__*/React.createElement(S.SubTitle, {
  "data-testid": DataTestIds.PractitionerCardSubTitle,
  size: size
}, subTitle), description && /*#__PURE__*/React.createElement(S.Description, {
  size: size,
  "data-testid": DataTestIds.PractitionerCardDescription
}, description))), footer && /*#__PURE__*/React.createElement(S.Footer, null, footer));
export default PractitionerDetails;